const CompetitionService = require("Scripts/gayl/competition-service");
const Cookie             = require('Vendor/js-cookie');

module.exports = CompetitionQuestionEntry;

function CompetitionQuestionEntry() {
	this.competitionService = CompetitionService;

	this.ui = {
		duplicateEntry: $('.js-winner-section-already-entered'),
		enterButton: $('.js-enter-competition'),
		entryError: $('.js-winner-section-entry-error'),
		grid: $('.js-puzzle-grid'),
		gridItems: $('.js-puzzle-grid-item'),
		loginSection: $('.js-winner-section-login'),
		loginButton: $('.js-go-login'),
		root: $('.js-competition-question-entry-widget'),
		signupSection: $('.js-winner-section-signup'),
		signupButton: $('.js-go-signup'),
		postEntryScreen: $('.js-winner-section-post-entry'),
		puzzlePage: $('.js-puzzle-page'),
		puzzleWrapper: $('.js-puzzle-wrapper'),
		winnerCongrats: $('.js-winner-section-congrats')
	};

	// Grab some state from DOM elements.
	this.state = {
		answer: parseInt(this.ui.grid.attr('data-answer'), 10),
		hasSolved: this.ui.grid.attr('data-has-solved') == "true",
		loggedIn: $(document.body).attr('data-logged-in') == "true",
		sectionId: parseInt(this.ui.root.attr('data-section-id'), 10)
	};

	this.init = function() {
		new FacebookLogin({
			onAuthSuccess: this.onAuthSuccess.bind(this)
		});

		new GenericLoginForm({
			onLoginSuccess: this.onAuthSuccess.bind(this)
		});

		new GenericSignupForm({
			onSignupSuccess: this.onAuthSuccess.bind(this)
		});

		this.bindEventHandlers();
	};

	this.bindEventHandlers = function() {

		// Make the grid items flip if they haven't solved it already.
		if(!this.state.hasSolved) {
			this.ui.gridItems.on('click', this.onClickGridItem.bind(this));
		}

		// Pre-entry navigation
		this.ui.winnerCongrats.find('.js-winner-section-show-signup').on('click', this.onClickSignup.bind(this));
		this.ui.winnerCongrats.find('.js-winner-section-show-login').on('click', this.onClickLogin.bind(this));

		// Entry button for logged in users.
		this.ui.enterButton.on('click', this.onEnterCompetition.bind(this));

		// To navigate between log in / sign up sections
		this.ui.loginButton.on('click', this.onClickLogin.bind(this));
		this.ui.signupButton.on('click', this.onClickSignup.bind(this));
	};

	this.enterCompetition = function(sectionId) {
		console.log("CompetitionQuestionEntry.enterCompetition");

		return this.competitionService.enter({
			sectionId: sectionId
		})
		.error(this.onEntryFailure.bind(this))
		.then(function(resp) {
			if(resp && resp.success) {
				self.onEntrySuccess();
			} else {
				self.onDuplicateEntry();
			}
		}.bind(this));
	};

	this.onEnterCompetition = function(e) {
		// Disable the button to prevent multiple submissions (verified server-side anyway, but lets stop it happening
		// in the first place)
		var clickedEl = $(e.currentTarget);
		clickedEl.prop('disabled', true);
		clickedEl.text('Entering...please wait.');

		this.enterCompetition(this.state.sectionId);
	};

	/**
	 * This is called when a user:
	 * - Logs in
	 * - Signs up
	 */
	this.onAuthSuccess = function(redirectUrl) {
		// After being authorised, immediately try and enter the competition
		this.enterCompetition(this.state.sectionId);
		this.ui.gridItems.off('click'); // Disable the grid events after signing up, otherwise the "you've found the thing" content will reappear.

		if(this.isMobileViewport()) {
			this.scrollToElement(this.ui.postEntryScreen);
		}
	};

	// Called when an anonymous user who has already entered whilst logged in, logs into their account
	// and tries to enter again.
	this.onDuplicateEntry = function() {
		this.ui.winnerCongrats.hide();
		this.ui.puzzlePage.show();
		this.ui.loginSection.hide();
		this.ui.signupSection.hide();
		this.ui.duplicateEntry.show();
	};

	this.onEntrySuccess = function() {
		this.ui.winnerCongrats.hide();
		this.ui.puzzlePage.show();
		this.ui.loginSection.hide();
		this.ui.signupSection.hide();
		this.ui.postEntryScreen.show();
	};

	this.onEntryFailure = function() {
		this.ui.winnerCongrats.hide();
		this.ui.loginSection.hide();
		this.ui.signupSection.hide();
		this.ui.entryError.show();
	};

	this.onClickSignup = function(e) {
		e.preventDefault(); // Don't follow links
		this.ui.puzzlePage.hide();
		this.ui.loginSection.hide();
		this.ui.signupSection.show();

		// Scroll to the top of the page on mobile viewports, otherwise you start halfway down the form
		if(this.isMobileViewport()) {
			this.scrollToElement($('.competition-question-entry-widget__signup'))
		}
	};

	this.onClickLogin = function(e) {
		e.preventDefault(); // Don't follow links
		this.ui.puzzlePage.hide();
		this.ui.signupSection.hide();
		this.ui.loginSection.show();

		// Scroll to the top of the page on mobile viewports, otherwise you start halfway down the form
		if(this.isMobileViewport()) {
			this.scrollToElement($('.competition-question-entry-widget__login'));
		}
	};

	this.onClickGridItem = function(e) {
		var clickedEl = $(e.currentTarget);
		var userGuess = parseInt(clickedEl.attr('data-id'), 10);

		// Ensure only one card is flipped at a time.
		this.unFlipAllCards();
		this.revealCard(clickedEl);

		if(userGuess === this.state.answer) {
			// Wait a little bit before showing the winning state, so the user has time
			// to acknowledge that they've actually won.
			setTimeout(function() {
				this.onWin();
			}.bind(this), 1000);
		}
	};

	this.revealCard = function(el) {
		// Flip the card that was clicked. If the browser is IE, or doesn't support CSS 3D animations, we just
		// show / hide the elements. IE supposedly supports css3d animations, but doesn't work the same as other browsers. So rather
		// than coming up with something that works with both, I've just disabled it completely on those browsers.
		if(this.supportsCss3dAnimations()) {
			el.find('.grid-card').toggleClass('is-flipped');
			// Work around a really weird thing I don't understand. Sometimes our SVG doesn't get rendered (it has display: none) on it....
			// this just shows it every time the card is clicked to prevent this happening. I don't really have time to figure out why it does this :)
			el.find('.svg-inline--fa').show();
		} else {
			el.find('.grid-card__face--front').hide()
			el.find('.grid-card__face--back').css('transform', 'none').show();
		}
	};

	this.onWin = function() {
		// Reveal the "you've won" section
		this.ui.winnerCongrats.show();

		// Scroll down to it on mobile. On desktop they sit side by side, on mobile they're stacked on top of each other.
		if(this.isMobileViewport()) {
			this.scrollToElement($(".js-winner-section-congrats-header"));
		}

		// Change the page layout...
		this.ui.puzzleWrapper
			.removeClass('col-sm-12')
			.addClass('col-sm-6')
			.addClass('col-md-7');

		Cookie.set('QUESTION_ENTRY_' + this.state.sectionId, true, { expiry: 0 })
	};

	this.unFlipAllCards = function() {
		// The card flipping works differently depending on the browser we're using.
		if(this.supportsCss3dAnimations()) {
			this.ui.gridItems.find('.grid-card').removeClass('is-flipped');
		} else {
			this.ui.gridItems.find('.grid-card__face--back').hide();
			this.ui.gridItems.find('.grid-card__face--front').show();
		}
	};

	// Scrolls the window to the given element, with the specified offset
	this.scrollToElement = function(el, offset) {
		// Set the offset to a default value if it wasn't given
		offset = (typeof offset !== 'undefined') ? offset : 0;

		$(document).scrollTop($(el).offset().top - offset);
	};

	// Determine whether the client supports CSS 3D animations and that they actually work as expected (*cough* IE)
	this.supportsCss3dAnimations = function() {
		if(this.isInternetExplorer()) {
			return false;
		}

		return Modernizr.csstransforms3d;
	};

	// Determine if the client has a mobile sized viewport
	this.isMobileViewport = function() {
		if(!window.matchMedia) { // Browser doesn't support this method, we can't determine if it's a mobile device.
			return false;
		}
		return window.matchMedia('(max-width: 767px)').matches
	};

	this.isInternetExplorer = function() {
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf('MSIE '); // IE 10 or older
		var trident = ua.indexOf('Trident/'); //IE 11

		return (msie > 0 || trident > 0);
	};

	this.init();
}